module.exports = __webpack_public_path__ + "static/media/child_care.d274660a.JPG";